import React from 'react';
import styled from 'styled-components';
import Location from '../../assets/target.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';
import Krill from '../../components/Krill/Krill';

const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:50vh;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

  
`;

class CardKrill extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
    
      <Krill/>       
    
      
            
    </Viz>

      <ReusableDetailCard
   trend= {Location}
   metricsm="Prevalent Worldwide"
   diagnosis="Krill – a shrimp-like crustacean – forms the basis of the marine food web for whales, seabirds, fish, squid, seals, and sharks throughout the world’s oceans."
   prediction="Krill depend on plankton for nutrients. The contamination of plankton with micriplastics recuces their nutritional value, and transfers toxins to higher tropic levels (NOAA)."
   significanceorthreat="SIGNIFICANCE"
   confidence="CONFICENCE LV: 95%"
   />
  </Container>
  );
 }
}

export default CardKrill;
